/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Administration {
    import fld = TenantRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TenantGrid extends NoboxEntityGrid<TenantRow, any> {
        protected getColumnsKey() { return TenantColumns.columnsKey; }
        protected getDialogType() { return TenantDialog; }
        protected getIdProperty() { return TenantRow.idProperty; }
        protected getInsertPermission() { return TenantRow.insertPermission; }
        protected getLocalTextPrefix() { return TenantRow.localTextPrefix; }
        protected getService() { return TenantService.baseUrl; }


        protected getButtons(): Serenity.ToolButton[] {

            var buttons = super.getButtons();
            var $this = this;

            buttons.push({
                title: 'Sync All DB',
                separator: true,
                icon:"fa-database",
                cssClass: 'send-button',
                onClick: () => {
                    Q.confirm("Sync All Db?", () => {
                        if (!this.onViewSubmit()) {
                            return;
                        }

                        var action = new SyncDbBulkAction();
                        //action.done = () => this.rowSelection.resetCheckedAndRefresh();
                        var tenantIds = this.getItems().map(x => x.Id.toString());
                        action.execute(tenantIds);
                    })
                }
            });
            return buttons;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: TenantViewEditor,
                field: 'Id',
                title: 'Subscription',
                handler: w => {
                    (this.view.params as TenantListRequest).View = Q.toId(w.value);
                },
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: TenantFilterMemberEditor,
                field: 'Member',
                title: 'Member',
                handler: w => {
                    (this.view.params as TenantListRequest).Member = Q.toId(w.value);
                },
                cssClass: 'hidden-xs'
            });

            return filters;
        }
    }
}